var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("resizable-common-dialog", {
    ref: "dialog",
    attrs: {
      title: "Branch",
      "dialog-visible": _vm.visible,
      rules: "rules",
      "start-dialog-height": "460",
      "start-dialog-width": "420",
    },
    on: {
      "update:dialogVisible": function ($event) {
        _vm.visible = $event
      },
      "update:dialog-visible": function ($event) {
        _vm.visible = $event
      },
    },
    scopedSlots: _vm._u([
      {
        key: "body",
        fn: function () {
          return [
            _c(
              "v-row",
              { attrs: { dense: "" } },
              [
                _c(
                  "v-col",
                  {
                    staticClass: "mb-n5",
                    attrs: { cols: "12", md: "12", sm: "12" },
                  },
                  [
                    _c(
                      "v-row",
                      { staticClass: "mt-3", attrs: { dense: "" } },
                      [
                        _c(
                          "v-col",
                          { attrs: { cols: "12", md: "12", sm: "12" } },
                          [
                            _c("v-text-field", {
                              attrs: {
                                disabled: "",
                                label: "UID:",
                                "hide-details": "",
                                outlined: "",
                                dense: "",
                              },
                              model: {
                                value: _vm.model.uid,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.model,
                                    "uid",
                                    typeof $$v === "string" ? $$v.trim() : $$v
                                  )
                                },
                                expression: "model.uid",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "v-row",
                  { staticClass: "mt-3", attrs: { dense: "" } },
                  [
                    _c(
                      "v-col",
                      { attrs: { cols: "16", md: "8", sm: "8" } },
                      [
                        _c("v-text-field", {
                          directives: [
                            { name: "ascii-only", rawName: "v-ascii-only" },
                          ],
                          attrs: { label: "Name:" },
                          model: {
                            value: _vm.model.name,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.model,
                                "name",
                                typeof $$v === "string" ? $$v.trim() : $$v
                              )
                            },
                            expression: "model.name",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      { attrs: { cols: "12", md: "4", sm: "4" } },
                      [
                        _c("v-text-field", {
                          attrs: { label: "Order:" },
                          model: {
                            value: _vm.model.order,
                            callback: function ($$v) {
                              _vm.$set(_vm.model, "order", _vm._n($$v))
                            },
                            expression: "model.order",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c("c-group-table", {
                  attrs: { readonly: _vm.readonly, items: _vm.model.groups },
                  on: {
                    "update:items": function ($event) {
                      return _vm.$set(_vm.model, "groups", $event)
                    },
                  },
                }),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "actions",
        fn: function () {
          return [
            _c(
              "v-btn",
              {
                attrs: { color: "blue darken-1", text: "" },
                on: { click: _vm.hide },
              },
              [_vm._v("Cancel")]
            ),
            _c(
              "v-btn",
              {
                attrs: { color: "blue darken-1", text: "" },
                on: { click: _vm.save },
              },
              [_vm._v("Save")]
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }